<template>
  <select
    :id="selectId"
    :class="selectClass"
    :name="name"
    :multiple="multiple"
    :disabled="disabled"
    v-model="modelValue"
    @change="$emit('change', modelValue)"
  >
    <option
      v-for="option in formattedOptions"
      :key="option.value + '-' + option.name"
      :value="option.value"
    >
      {{ option.name }}
    </option>
  </select>
</template>

<script>
import { head, map } from 'ramda'
import { isObj } from 'ramda-adjunct'

export default {
  name: 'app-select',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    selectId: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Array, String, Number, Boolean],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultFirstOption: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modelValue: this.getModelValue()
    }
  },
  computed: {
    formattedOptions() {
      if (!isObj(head(this.options))) {
        return map(option => ({
          value: option,
          name: option
        }), this.options)
      }

      return this.options
    },
    selectClass() {
      return {
        'app-select-multiple': this.multiple
      }
    }
  },
  methods: {
    getModelValue() {
      let modelValue

      if (this.multiple) {
        if (this.value instanceof Array) {
          modelValue = this.value
        } else if (this.value !== null) {
          modelValue = [this.value]
        } else {
          modelValue = []
        }
      } else if (this.defaultFirstOption) {
        modelValue = this.value || (this.options[0] && this.options[0].value)
      } else {
        modelValue = this.value
      }

      return modelValue
    }
  },
  watch: {
    value(v) {
      this.modelValue = v
    },
    options() {
      this.modelValue = this.getModelValue()
    }
  }
}
</script>
